import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as LinkUtils from './LinkUtils'
import PagesModal from '../PagesModal'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,
  Form, FormGroup, Label, Input, UncontrolledTooltip } from 'reactstrap'
import styles from './LinkSlatePlugin.scss'
import {Link} from 'react-router-dom'

const { updateLinkStrategy, unlink } = LinkUtils

class LinkModal extends Component {
  constructor (props) {
    super(props)

    const { node } = this.props

    const attributes = node.data.toJS()

    this.state = {
      attributes: {
        ...attributes,
        text: this.props.presetData.text
      },
      isPagesModalOpen: false,
      isEditing: true
    }
  }

  updateTextFromContent = (nextProps) => {
    this.setLinkAttribute('text', nextProps.presetData.text)
  }

  componentWillUpdate (nextProps, nextState) {
    if (!this.props.isOpen && nextProps.isOpen) {
      // the modal will be opened
      this.updateTextFromContent(nextProps)
    }
  }

  componentDidMount () {
    if (this.inputHref) {
      this.inputHref.focus()
    }

    this.setLinkAttribute('text', this.props.presetData.text)
  }

  setLinkAttribute (attributeName, value) {
    const attributes = {
      ...this.state.attributes,
      [attributeName]: value
    }
    const _state = { attributes }
    if (name === 'text') {
      _state.presetData = { text: value }
    }
    this.setState(_state)
  }

  onKeyDown = (synthetic, event) => {
    // return
    if (synthetic.keyCode === 13) {
      this.onSubmit(synthetic)
    }
  }

  onChangeOpensExternal = event => {
    const value = event.target.checked ? '_blank' : '_self'
    this.setLinkAttribute(event.target.name, value)
  }

  onChangeToExternal = (event) => {
    this.setLinkAttribute(event.target.name, false)
  }

  onChangeToInternal = (event) => {
    this.setLinkAttribute(event.target.name, true)
  }

  toggle = () => {
    const isOpen = !this.props.isOpen
    if (isOpen) {
      return this.props.changeModalState(true)
    }
    this.onCancel()
  }

  onCancel = () => {
    const { node } = this.props
    if (!node.data.get('href')) this.props.onChange(unlink(this.props.state))
    this.props.changeModalState(false)
    this.setState({isEditing: false})
  }

  onSubmit = e => {
    e.preventDefault()

    const attributes = {...this.state.attributes}

    // restore link text
    if (!attributes.text) {
      attributes.text = this.props.presetData.text
    }

    // ensure internal link is valid
    if (attributes.isInternalLink && (!attributes.pageId || !attributes.href)) {
      attributes.isInternalLink = false
    }

    // ensure external has no internal link stuff
    if (!attributes.isInternalLink) {
      attributes.pageId = null
      attributes.pageTitle = null
    }

    // close modal
    attributes.openModal = false

    if (!attributes.href) {
      this.props.onChange(unlink(this.props.state))
    } else {
      this.props.onChange(updateLinkStrategy({ state: this.props.state, data: attributes }))
    }

    this.setState({attributes})

    this.props.changeModalState(false)
  }

  changePagesModalState = (bool) => {
    this.setState({isPagesModalOpen: bool})
  }

  onSelectPage = page => {
    this.changePagesModalState(false)
    const attributes = {
      ...this.state.attributes,
      pageId: page.id,
      href: page.path,
      pageTitle: page.title
    }
    this.setState({attributes})
  }

  render () {
    const isInternalLink = this.state.attributes.isInternalLink
    const isFile = this.state.attributes.isFile
    const isExternal = !isFile && !isInternalLink

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.toggle} size='lg' >
        <ModalHeader toggle={this.toggle}>Edit Link</ModalHeader>
        <ModalBody onKeyDown={this.onKeyDown}>

          {/* Internal page or External URL */}
          {
            !isFile &&
            <Form inline>
              <FormGroup check>
                <Label check>
                  <Input type='radio' name='isInternalLink'
                    checked={isInternalLink}
                    onChange={this.onChangeToInternal} />{' '}
                  Internal Page
                </Label>
              </FormGroup>
              &nbsp;&nbsp;
              <FormGroup check>
                <Label check selected>
                  <Input type='radio' name='isInternalLink'
                    checked={!isInternalLink}
                    onChange={this.onChangeToExternal} />{' '}
                  External URL{' '}
                </Label>
              </FormGroup>
            </Form>
          }

          {/* Select internal page */}
          {isInternalLink &&
            <div style={{margin: '20px 0'}}>
              {this.state.attributes.pageId &&
                this.state.attributes.href &&
                <div>
                  <Link to={`/pages/edit/${this.state.attributes.pageId}`}>
                    ✨ {this.state.attributes.href}
                  </Link>
                </div>
              }
              <Button color='primary' onClick={() => this.changePagesModalState(true)}>Select Page</Button>
              <PagesModal
                currentPageId={this.props.pageId}
                initialParentId={this.props.parentId}
                onSelect={this.onSelectPage}
                changeModalState={this.changePagesModalState}
                isOpen={this.state.isPagesModalOpen}
                />
            </div>
          }

          {/* External href */}
          {isExternal &&
            <Form name='LinkForm' style={{margin: '20px 0'}}>
              <FormGroup>
                <Input type='text' name='href' id='link-href' placeholder='URL'
                  onClick={e => e.stopPropagation()}
                  onChange={e => this.setLinkAttribute(e.target.name, e.target.value)}
                  defaultValue={this.state.attributes.href}
                  getRef={input => { this.inputHref = input }}
                  autoFocus
                   />
              </FormGroup>
            </Form>
          }

          {/* Open file url */}
          {
            isFile &&
            <div>
              <a href={this.state.attributes.href} target='_blank'>Open file: {this.state.attributes.text}</a>
              <hr />
            </div>
          }

          {/* Open link in new window */}
          {
            !isExternal && this.state.attributes.pageId &&
            <FormGroup check>
              <Label check>
                <Input type='checkbox' name='target'
                  onClick={e => e.stopPropagation()}
                  onChange={this.onChangeOpensExternal}
                  checked={this.state.attributes.target === '_blank'} />{' '}
                  Link opens in new window
              </Label>
            </FormGroup>
          }

          {/* Link text */}
          <b>Link Text: <span id='linkTextTooltip'>💁</span></b>
          <UncontrolledTooltip placement='top' target='linkTextTooltip'>
            The text of the link that the user will see in the content
          </UncontrolledTooltip>
          <FormGroup>
            <Input type='text' name='text' id='link-text' placeholder='e.g. Click here'
              onClick={e => e.stopPropagation()}
              onChange={e => this.setLinkAttribute(e.target.name, e.target.value)}
              value={this.state.attributes.text}
               />
          </FormGroup>

          {/* Link styles */}
          <b>Link Style: <span id='linkStyleTooltip'>💁</span></b>
          <UncontrolledTooltip className={styles.linkStyleTooltip} placement='top' target='linkStyleTooltip'>
            Link Style Examples:
            <img src='/images/link_style_examples.png' />
          </UncontrolledTooltip>
          <Form inline>
            <FormGroup check>
              <Label check>
                <Input type='radio' name='linkStyle'
                  checked={!this.state.attributes.linkStyle || this.state.attributes.linkStyle === 'default'}
                  onChange={() => this.setLinkAttribute('linkStyle', 'default')} />{' '}
                Default
              </Label>
            </FormGroup>
            &nbsp;&nbsp;
            <FormGroup check>
              <Label check selected>
                <Input type='radio' name='linkStyle'
                  checked={this.state.attributes.linkStyle === 'block'}
                  onChange={() => this.setLinkAttribute('linkStyle', 'block')} />{' '}
                Block
              </Label>
            </FormGroup>
            &nbsp;&nbsp;
            <FormGroup check>
              <Label check selected>
                <Input type='radio' name='linkStyle'
                  checked={this.state.attributes.linkStyle === 'file'}
                  onChange={() => this.setLinkAttribute('linkStyle', 'file')} />{' '}
                File
              </Label>
            </FormGroup>
            &nbsp;&nbsp;
            <FormGroup check>
              <Label check selected>
                <Input type='radio' name='linkStyle'
                  checked={this.state.attributes.linkStyle === 'button'}
                  onChange={() => this.setLinkAttribute('linkStyle', 'button')} />{' '}
                Button
              </Label>
            </FormGroup>
            &nbsp;&nbsp;
            <FormGroup check>
              <Label check selected>
                <Input type='radio' name='linkStyle'
                  checked={this.state.attributes.linkStyle === 'heading'}
                  onChange={() => this.setLinkAttribute('linkStyle', 'heading')} />{' '}
                Heading
              </Label>
            </FormGroup>
          </Form>

          {/* Edit file */}
          {
            isFile &&
            <div>
              <hr />
              <Link to={`/files/${this.state.attributes.fileId}/replace`} target='_blank'>Replace original file</Link>
            </div>
          }

          {false &&
            <div className='debug-block'>
              state
              <pre>{JSON.stringify(this.state, null, 4)}</pre>
              props.presetData
              <pre>{JSON.stringify(this.props.presetData, null, 4)}</pre>
              props.node.data
              <pre>{JSON.stringify(this.props.node.get('data'), null, 4)}</pre>
            </div>
          }

        </ModalBody>
        <ModalFooter>
          <Button form='LinkForm' color='primary' type='submit' onClick={this.onSubmit}>Save</Button>{' '}
          <Button form='LinkForm' color='secondary' onClick={this.onCancel}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

LinkModal.propTypes = {
  pageId: PropTypes.number,
  parentId: PropTypes.number,
  isOpen: PropTypes.bool,
  node: PropTypes.shape({
    data: PropTypes.shape({
      get: PropTypes.func.isRequired
    }),
    get: PropTypes.func.isRequired
  }),
  state: PropTypes.object.isRequired,
  changeModalState: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  presetData: PropTypes.shape({
    text: PropTypes.string
  })
}

export default LinkModal



// WEBPACK FOOTER //
// ./src/components/LinkSlatePlugin/LinkModal.js